export enum LoadingResource {
  Result = `result`,
  ApiResources = `apiResources`,
}

export enum ReportEditorActivePanel {
  QueryBuilder = `query`,
  ChartCustomization = `chart-customization`,
}
